import { HelixIcon } from '@helix/helix-icon'
import { wolfie } from '@helix/helix-icon/outlined'
import { platformLauncherUrl } from './utils'

export function PlatformLoginButton() {
  return (
    <a className="block hover:no-underline" href={platformLauncherUrl}>
      <button className="helix-btn helix-btn--primary helix-btn--medium helix-d-flex helix-align--center helix-justify--center w-full gap-2">
        <HelixIcon icon={wolfie} className="h-6 w-6 shrink-0" />
        <span>Sign in with Lone Wolf Account</span>
      </button>
    </a>
  )
}
